import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './IconElement.css';

function IconElement({ element, isPreviewMode, onUpdate }) {
  const { icon, style = {} } = element;
  
  const handleClick = (e) => {
    if (isPreviewMode) return;
    e.stopPropagation();
  };
  
  return (
    <div 
      className="icon-element"
      onClick={handleClick}
      style={{
        ...style,
        cursor: isPreviewMode ? 'default' : 'move',
        userSelect: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease'
      }}
    >
      <FontAwesomeIcon 
        icon={icon} 
        style={{
          width: '100%',
          height: '100%',
          color: style.color || '#333333',
          opacity: style.opacity || 1,
          transform: `rotate(${style.rotation || 0}deg)`
        }}
      />
    </div>
  );
}

export default IconElement; 